import { useDispatch } from "react-redux"
import { isEmpty } from 'lodash';
// actions
import SiteSettingsServiceAction from "@/cms/actions/common/SiteSettingsServiceAction";


const useClientSiteSettings = () => {
    const dispatch = useDispatch();

    const siteSettingsServiceAction = new SiteSettingsServiceAction(dispatch);

    const armadorStaticPayload = document?.getElementById('ARMADORStaticPayload')?.textContent;
    const _armadorStaticPayload = JSON.parse(armadorStaticPayload||"");

    if ( !isEmpty(_armadorStaticPayload) ) {
        siteSettingsServiceAction.detailsStore({ payload:_armadorStaticPayload["settings"] });
        return true;
    }

    return false;
}

export default useClientSiteSettings;
